export const OPEN_POPUP = "OPEN_POPUP";
export const POPUP_FIRST_TIME = "POPUP_FIRST_TIME";
export const CLOSE_POPUP = "CLOSE_POPUP";